module.exports = __webpack_public_path__ + "media/img/frontend_application/good_bye-de76ee279aac1a57db98a82b61ec15d6.png";